import { ErrorModal, useOpenModal } from '@modusign/design-system';
import { useMemo } from 'react';

type ErrorProp = Parameters<typeof ErrorModal>[0]['error'];
export type ErrorMessageMapper = Record<string, string | string[]>;

export default function useOpenErrorModal(param?: { keepOnUnmount?: boolean }) {
  const open = useOpenModal();

  const handleError = useMemo(
    () =>
      (
        params: {
          title: string;
          error: ErrorProp;
          onConfirm?: () => void;
        },
        additionalErrorMessages?: ErrorMessageMapper
      ) =>
        open(
          ({ isOpen, onClose }) => (
            <ErrorModal
              error={params.error}
              errorMessageMapper={additionalErrorMessages}
              isOpen={isOpen}
              title={params.title}
              onClose={() => {
                onClose();
                params.onConfirm?.();
              }}
            />
          ),
          { keepOnUnmount: param?.keepOnUnmount }
        ),
    [open, param?.keepOnUnmount]
  );

  return {
    handleError,
    createErrorHandler:
      (
        params: { title: string; onConfirm?: () => void },
        additionalErrorMessages?: ErrorMessageMapper
      ) =>
      (error: ErrorProp) =>
        handleError(
          { title: params.title, error, onConfirm: params.onConfirm },
          additionalErrorMessages
        ),
  };
}
